import Avatar from './Avatar'

export default Avatar
// eslint-disable-next-line import/export
export * from './Avatar'
